module.exports = __webpack_public_path__ + "static/media/shop.df3ca24b.svg";